export default "__VITE_ASSET__EwpqM1kl__"